<template>
    <div>
        <Navbar />
        <PageTitle subTitle="Fale Conosco" heding="Transformando ideias em soluções digitais" />
        <Contact />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import Contact from '../Contact/Contact'
import Footer from '../Layouts/Footer'


export default {
    name: 'ContactPage',
    components: {
        Footer,
        Navbar,
        PageTitle,
        Contact,
    }
}
</script>